import { useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useLocation, useParams } from "react-router-dom";
import { push } from "connected-react-router";
import { isEmpty } from "lodash";
import { actions as formActions } from "reducers/form";
import { transactionStatus } from "pages/transactions/constants";
import { formatAction } from "util/creditBills";

export const useTransaction = (signAction, cleanAction) => {
    const dispatch = useDispatch();
    const { pathname, state = {} } = useLocation();
    const { isFlowComplete = false } = state;
    const { id } = useParams();

    const { transaction, fetching: isLoading } = useSelector((_state) => _state.form);

    const { actionInLowerCase, actionI18n } = formatAction(transaction?.data?.action);

    const isBackoffice = pathname.includes("backoffice");
    const isFinished = transactionStatus.FINISHED === transaction.idTransactionStatus;
    const isProcessing = transactionStatus.PROCESSING === transaction.idTransactionStatus;
    const isPending = transactionStatus.PENDING === transaction.idTransactionStatus;
    const isCancelled = transactionStatus.CANCELLED === transaction.idTransactionStatus;

    const { user } = useSelector((_state) => _state.session);

    const showSignButton =
        isEmpty(transaction?.signatures?.find((sign) => sign.idUser === user?.userId)) &&
        transaction.idTransactionStatus === transactionStatus.PENDING;

    const handleSignTransaction = () => {
        const { data, idTransaction } = transaction;
        dispatch(signAction({ ...data, idTransaction }));
        dispatch(push(`/creditBills/${actionInLowerCase}/confirm`));
    };

    useEffect(() => {
        if (id && isEmpty(state?.transaction)) {
            dispatch(formActions.readAgreementTransaction(id));
        }
    }, [id, dispatch]);

    useEffect(
        () => () => {
            dispatch(cleanAction());
        },
        [],
    );

    return {
        isLoading,
        transaction,
        actionI18n,
        handleSignTransaction,
        showSignButton,
        push,
        dispatch,
        id,
        status: { isFinished, isProcessing, isFlowComplete, isPending, isCancelled, isBackoffice },
    };
};

export default useTransaction;
